import type { JSX } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { monoLabel } from '../shell/look';

/** The email box, registered with the sign-in's email form (auth/sign-in.ts has its schema). */
export function EmailStep({ field }: { field: UseFormRegisterReturn<'email'> }): JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="sign-in-email" className={monoLabel}>
        WORK EMAIL
      </label>
      <input
        id="sign-in-email"
        type="email"
        {...field}
        autoFocus
        autoComplete="email"
        placeholder="you@northlinefreight.com"
        className="bg-bg w-full rounded-[11px] border px-3.5 py-3 text-[14.5px]"
      />
    </div>
  );
}
